<!-- Built with Common Launchpad 2.0.3 -->

<template>
    <section>
        <div v-if="isLoading" class="qualifier-tool-loading"></div>
        <wqtstep1 v-bind:model="model" v-if="currentStep == 0"></wqtstep1>
        <wqtstep2a v-bind:model="model" v-if="currentStep == 1"></wqtstep2a>
        <wqtstep2b v-bind:model="model" v-if="currentStep == 2"></wqtstep2b>
        <wqtstep3a v-bind:model="model" v-if="currentStep == 3"></wqtstep3a>
        <wqtstep3b v-bind:model="model" v-if="currentStep == 4"></wqtstep3b>
        <wqtstep3c v-bind:model="model" v-if="currentStep == 5"></wqtstep3c>
        <wqtstep3d v-bind:model="model" v-if="currentStep == 6"></wqtstep3d>
        <wqtstep3e v-bind:model="model" v-if="currentStep == 7"></wqtstep3e>
        <wqtstep3f v-bind:model="model" v-if="currentStep == 14"></wqtstep3f>
        <wqtstep4a v-bind:model="model" v-if="currentStep == 8"></wqtstep4a>
        <wqtstep4b v-bind:model="model" v-if="currentStep == 9"></wqtstep4b>
        <wqtstep5a v-bind:model="model" v-if="currentStep == 10"></wqtstep5a>
        <wqtstep5b v-bind:model="model" v-if="currentStep == 11"></wqtstep5b>
        <wqtstep6a v-bind:model="model" v-if="currentStep == 12"></wqtstep6a>
        <wqtstep6b v-bind:model="model" v-if="currentStep == 13"></wqtstep6b>
        <wqtstep6c v-bind:model="model" v-if="currentStep == 15"></wqtstep6c>        
    </section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';
    import VeeValidate, {Form, Field} from 'vee-validate';
    import WQTStep1 from '../containers/web-qualifier-tool-steps/step-1/wqt-step-1';
    import WQTStep2a from '../containers/web-qualifier-tool-steps/step-2/wqt-step-2a';
    import WQTStep2b from '../containers/web-qualifier-tool-steps/step-2/wqt-step-2b';
    import WQTStep3a from '../containers/web-qualifier-tool-steps/step-3/wqt-step-3a';
    import WQTStep3b from '../containers/web-qualifier-tool-steps/step-3/wqt-step-3b';
    import WQTStep3c from '../containers/web-qualifier-tool-steps/step-3/wqt-step-3c';
    import WQTStep3d from '../containers/web-qualifier-tool-steps/step-3/wqt-step-3d';
    import WQTStep3e from '../containers/web-qualifier-tool-steps/step-3/wqt-step-3e';
    import WQTStep3f from '../containers/web-qualifier-tool-steps/step-3/wqt-step-3f';
    import WQTStep4a from '../containers/web-qualifier-tool-steps/step-4/wqt-step-4a';
    import WQTStep4b from '../containers/web-qualifier-tool-steps/step-4/wqt-step-4b';
    import WQTStep5a from '../containers/web-qualifier-tool-steps/step-5/wqt-step-5a';
    import WQTStep5b from '../containers/web-qualifier-tool-steps/step-5/wqt-step-5b';
    import WQTStep6a from '../containers/web-qualifier-tool-steps/step-6/wqt-step-6a';
    import WQTStep6b from '../containers/web-qualifier-tool-steps/step-6/wqt-step-6b';
    import WQTStep6c from '../containers/web-qualifier-tool-steps/step-6/wqt-step-6c';

	export default {
		props: ['model', 'formname', 'formversion', 'uniqueformname', 'referringbutton', 'urlreferrer'],
		data: function () {
			return {
                
			}
		},
		computed: mapState({
            currentStep: state => state.WebQualifierTool.currentStep,
            isLoading: state => state.WebQualifierTool.isLoading            
		}),
		components: {
			'wqtstep1': WQTStep1,
            'wqtstep2a': WQTStep2a,
            'wqtstep2b': WQTStep2b,
            'wqtstep3a': WQTStep3a,
            'wqtstep3b': WQTStep3b,
            'wqtstep3c': WQTStep3c,
            'wqtstep3d': WQTStep3d,
            'wqtstep3e': WQTStep3e,
            'wqtstep3f': WQTStep3f,
            'wqtstep4a': WQTStep4a,
            'wqtstep4b': WQTStep4b,
            'wqtstep5a': WQTStep5a,
            'wqtstep5b': WQTStep5b,
            'wqtstep6a': WQTStep6a,
            'wqtstep6b': WQTStep6b,
            'wqtstep6c': WQTStep6c,
		},
		mounted: function () {	
            let _this = this;

            let formData = {
                formName: this.formname,
                formVersion: this.formversion,
                referringButton: this.getQueryParams("button"),
                urlReferrer: this.urlreferrer,
                utmData: this.getUtmData()
            }
            
            this.initData(formData);
            
            const dictionary = {
	            en: {
                    messages: {
			            required: () => this.model.RequiredMessage,
                    },	
		            custom: {
			            Email: {
				            email: () => this.model.ValidEmailMessage
			            },
			            ConfirmEmail: {
				            confirmed: () => this.model.ConfirmEmailMessage,
				            required: () => this.model.RequiredMessage,
				            email: () => this.model.ConfirmEmailMessage
			            },
			            Phone: {
				            min: () => this.model.ValidPhoneMessage
			            },
			            ConfirmPhone: {
				            confirmed: () => this.model.ConfirmPhoneMessage,
				            required: () => this.model.RequiredMessage,
				            min: () => this.model.ValidPhoneMessage
			            },
			            PostalCode: {
				            min: () => this.model.ZipCodeValidMessage,
				            max: () => this.model.ZipCodeValidMessage,
				            required: () => this.model.RequiredMessage,
				            numeric: () => this.model.ZipCodeValidMessage
			            }
		            }	
	            },	
            };

            // Override and merge the dictionaries
            VeeValidate.Validator.localize(dictionary);

		},
		methods: {
            ...mapActions('WebQualifierTool', { updateStep: 'updateStep' }),
            ...mapMutations('WebQualifierTool', { initData: 'initData' }),
            ...mapMutations('WebQualifierTool', { setLoadingState: 'setLoadingState' }),
            getQueryParams(param) {
				let uri = window.location.search.substring(1);
				let params = new URLSearchParams(uri);                
				return params.get(param);
			},
            getUtmData() {
                let uri = window.location.search.substring(1);
				let params = new URLSearchParams(uri);
                params.delete("button");           
				return params.toString();
            }
        },
    }
</script>
